import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHornLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21 3.42569C21 2.48922 19.9951 1.86321 19.1486 2.32773C18.0119 2.95158 14.6462 4.76973 12.6307 5.57069C10.2859 6.50249 8.26651 6.85245 5.9533 6.95974C4.34937 7.03413 3 8.32857 3 9.99999V14C3 15.6714 4.34937 16.9659 5.9533 17.0402C6.22676 17.0529 6.49612 17.069 6.76239 17.089L6.01942 20.8039C5.91111 21.3454 6.26232 21.8723 6.80388 21.9806C7.34544 22.0889 7.87227 21.7377 7.98058 21.1961L8.75415 17.3283C10.0174 17.5434 11.2692 17.8883 12.6307 18.4293C14.6462 19.2303 18.0119 21.0484 19.1486 21.6723C19.995 22.1368 21 21.5108 21 20.5743V3.42569ZM9 15.3416C10.4181 15.5767 11.8333 15.9603 13.3693 16.5707C15.0217 17.2274 17.4558 18.4899 19 19.3169V4.68311C17.4558 5.51005 15.0217 6.77263 13.3693 7.4293C11.8333 8.03971 10.4181 8.42331 9 8.65843V15.3416ZM7 8.89857C6.68528 8.92326 6.36769 8.94267 6.04595 8.95759C5.44311 8.98555 5 9.46227 5 9.99999V14C5 14.5377 5.44311 15.0144 6.04596 15.0424C6.36769 15.0573 6.68528 15.0767 7 15.1014V8.89857Z"
	})
});
export default SvgHornLine;
